import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Collapse,
  Card,
  CardBody
} from 'reactstrap';

import DownSVG from '../../../shared/assets/arrow-down-black.svg';

class CollapsingSection extends Component {
  getTitle(){
    if(typeof this.props.title === 'string'){
      return (<strong>{this.props.title}</strong>);
    } else{
      return this.props.title;
    }
  }

  handleHeaderClick(){
    if(this.props.locked) return;
    this.props.onOpenClick();
  }

  render(){
    const {
      subtitle,
      open,
      children,
      locked,
      titleWidthInColumns,
      showBoxShadow,
      valid
    } = this.props;

    return (
      <Card className={showBoxShadow ? '' : 'NoBoxShadow'}>
        <CardBody>
          <Row
            onClick={() => this.handleHeaderClick()}
            style={{cursor:'pointer'}}
          >
            <Col 
              md={open ? 12 : titleWidthInColumns + 2}
              lg={open ? 12 : titleWidthInColumns}
            >
              {this.getTitle()}
            </Col>
            {!open && (
              <Col 
                md={8 - titleWidthInColumns}
                lg={10 - titleWidthInColumns}
              >
                {subtitle}
              </Col>
            )}
            {!open && (
              <Col xs='2'>
                <div className='pull-right'>
                  {!valid && (
                    <i className='fa fa-exclamation-triangle DangerFeedback' />
                  )}
                  {!locked && (
                    <img
                      src={DownSVG}
                      style={{height:18}}
                      alt='Open'
                    />
                  )}
                </div>
              </Col>
            )}
          </Row>
          <Collapse isOpen={open}>
            <br />
            {children}
          </Collapse>
        </CardBody>
      </Card>
    );
  }
}

CollapsingSection.propTypes = {
  titleWidthInColumns:PropTypes.number,
  title:PropTypes.node.isRequired,
  subtitle:PropTypes.node,
  onOpenClick:PropTypes.func,
  open:PropTypes.bool,
  children:PropTypes.node,
  locked:PropTypes.bool,
  showBoxShadow:PropTypes.bool,
  valid:PropTypes.bool
}

CollapsingSection.defaultProps = {
  onOpenClick:() => {},
  open:false,
  locked:false,
  titleWidthInColumns:4,
  showBoxShadow:false,
  valid:true
};

export default CollapsingSection;



// WEBPACK FOOTER //
// ./src/shared/components/CollapsingSection/index.js